type ProductTabsProps = {
  label: string;
  value: 'core' | 'progress' | 'taxplan' | 'engage' | 'protect';
};

export const productTabs: ProductTabsProps[] = [
  {
    label: 'Core',
    value: 'core',
  },
  {
    label: 'Progress',
    value: 'progress',
  },
  {
    label: 'Tax Plan',
    value: 'taxplan',
  },
  {
    label: 'Engage',
    value: 'engage',
  },
  {
    label: 'Protect',
    value: 'protect',
  },
];
